/* Renis Wollshop — predictive search. Ported from shop-header.jsx HeaderSearch, but hits
   Shopify's native /search/suggest.json instead of filtering an in-memory product array. */
(function () {
  'use strict';
  var debounceTimers = new WeakMap();

  function debounce(el, fn, ms) {
    clearTimeout(debounceTimers.get(el));
    debounceTimers.set(el, setTimeout(fn, ms));
  }

  function render(root, data, query) {
    var results = root.querySelector('[data-predictive-search-results]');
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    if (!products.length) {
      results.innerHTML = '<div class="rw-search-empty">Keine Treffer für „' + query.replace(/</g, '') + '“.</div>';
    } else {
      results.innerHTML = products.slice(0, 5).map(function (p) {
        return (
          '<a href="' + p.url + '" class="rw-search-result">' +
          '<span class="rw-search-result__img">' + (p.image ? '<img src="' + p.image + '&width=80" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="rw-search-result__body"><span class="rw-search-result__title">' + p.title + '</span>' +
          '<span class="rw-search-result__vendor">' + (p.vendor || '') + '</span></span>' +
          '<span class="rw-search-result__price">' + p.price + '</span>' +
          '</a>'
        );
      }).join('') + '<a href="' + root.querySelector('form').action + '?q=' + encodeURIComponent(query) + '&type=product" class="rw-search-viewall">Alle Ergebnisse anzeigen →</a>';
    }
    results.hidden = false;
  }

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-predictive-search-input]');
    if (!input) return;
    var root = input.closest('[data-predictive-search]');
    var results = root.querySelector('[data-predictive-search-results]');
    var query = input.value.trim();
    if (!query) { results.hidden = true; results.innerHTML = ''; return; }
    debounce(input, function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5&resources[options][fields]=title,vendor,product_type')
        .then(function (r) { return r.json(); })
        .then(function (data) { render(root, data, query); })
        .catch(function () {});
    }, 200);
  });

  document.addEventListener('focusin', function (e) {
    var input = e.target.closest('[data-predictive-search-input]');
    if (input && input.value.trim()) {
      var root = input.closest('[data-predictive-search]');
      var results = root.querySelector('[data-predictive-search-results]');
      if (results.innerHTML) results.hidden = false;
    }
  });

  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-predictive-search]').forEach(function (root) {
      if (!root.contains(e.target)) {
        var results = root.querySelector('[data-predictive-search-results]');
        if (results) results.hidden = true;
      }
    });
  });
})();
